<template>
  <!-- <h2>比較結果</h2> -->
  <div class="button-area">
    <button @click="handleChangeFilter" v-if="!isClearFilter" >自分のページと競合の差が0.1以上の単語を表示中</button>
    <button @click="handleChangeFilter" v-if="isClearFilter" >すべての単語を表示中</button>
    <button @click="handleDownloadCsv">CSVファイルダウンロード</button>
  </div>
  <div class="result-table" ref="table" ></div>
  <hr>
</template>

<script>
import {ref, onMounted} from 'vue';
import {TabulatorFull as Tabulator} from 'tabulator-tables';

export default {
  props: ['result'],
  setup(props){
    const resultText = ref('');

    const table = ref(null);
    const tabulator = ref(null);
    const tableData = ref([]);
    const columns = ref([]);
    const initialSort = ref([])
    const isClearFilter = ref(false)
    
    tableData.value = props.result.data;

    const fieldNames = props.result.schema.fields.map(fields => fields.name);
    columns.value = fieldNames.map(name => ({title: name, field: name}) );

    // 最後のcolumnの"gte_0.1_diff"は表示しない
    columns.value[columns.value.length - 1]['visible'] = false;
    
    // 初期ソートは3列目（ライバル記事）以降、最後（最後は自分の記事とのTF-IDF値の差）の手前までを降順
    initialSort.value = fieldNames.slice(2, -1).map(name => ({column: name, dir: "desc"}))
    initialSort.value.reverse() // ソートの複数項目の指定は逆順の模様...

    onMounted(() => {
      tabulator.value = new Tabulator(table.value, {
        data: tableData.value,
        layout:"fitColumns",
        // autoColumns: true,
        columns: columns.value,
        nestedFieldSeparator:"|",   //for url field name contains dot
        initialSort: initialSort.value,
        columnHeaderSortMulti:true,
        // initialFilter:[{field: "gte_0.1_diff", type: "=", value: true}],
        height:"100%",
        pagination:true,
        paginationSize:20,
      })
      // 初期フィルター切り替え
      const checkFilter = props.result.data.filter(x => x["gte_0.1_diff"])
      if (checkFilter.length > 0) {
        tabulator.value.on("tableBuilt", () => {
          tabulator.value.setFilter("gte_0.1_diff", "=", true);
        });
        isClearFilter.value = false
      } else {
        isClearFilter.value = true
      }
    });

    const handleChangeFilter = () => {
      if (isClearFilter.value) {
        tabulator.value.setFilter("gte_0.1_diff", "=", true);
      } else {
        tabulator.value.clearFilter();
      }
      isClearFilter.value = !isClearFilter.value
    }

    function json2csv(data) {
      const replacer = (key, value) => value === null ? '' : value
      const header = Object.keys(data[0])
      return [
        header.join(','),
        ...data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
      ].join('\r\n')
    }

    const handleDownloadCsv = () => {
      const bom  = new Uint8Array([0xEF, 0xBB, 0xBF]);
      const url = URL.createObjectURL(new Blob([bom, json2csv(props.result.data)], {type: 'text/plain'}));

      const link = document.createElement('a');
      link.href = url;
      link.innerText = 'Download CSV File';

      document.body.appendChild(link);
      link.download = 'data.csv'
      link.click();
      link.parentNode.removeChild(link);

    }
    return {resultText, tabulator, table, handleChangeFilter, isClearFilter, handleDownloadCsv}
  }
}

</script>

<style>
@import  "tabulator-tables";

  .result-table {
    margin-bottom: 20px;
  }
  .button-area {
    margin: 10px auto;
    display: flex;
    justify-content: space-between;
  }
</style>
